import React, {
    useState,
    useEffect,
    useMemo,
    useCallback,
    useRef,
} from "react";
import './styles.css'
export default function Attribute({attr ,saveField}){
    return <div className="contact-attr" style={{
        // padding: '20px 40px',
        // width: '100%'
    }}>
        <h6 >{attr.label}</h6>
        <input
         required={attr.label=='Email'? true: false}
            // style={{
            //     width: '80%',
            //     padding: '7px',
            //     margin: '10px',
            //     outline: '2px'
            // }}
            value={attr.value}
            onChange={(e) => saveField({key:attr.key , value: e.target.value})}

        ></input>
    </div>;
}